var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    height: "100%",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st1{fill:#ACACAC;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M678.9,472.8c-3.2-1.5-6.5-3-9.8-4.5C663.3,361.6,605,300.6,507.2,300c-0.4,0-0.9,0-1.3,0  c-58.5,0-107.2,25-137.2,70.4l53.8,36.9c22.4-34,57.5-41.2,83.4-41.2c0.3,0,0.6,0,0.9,0c32.2,0.2,56.5,9.6,72.3,27.8  c11.5,13.3,19.1,31.7,22.9,54.9c-28.6-4.9-59.5-6.3-92.5-4.5c-93,5.4-152.8,59.6-148.8,135c2,38.2,21.1,71.1,53.6,92.6  c27.5,18.2,63,27.1,99.8,25c48.7-2.7,86.8-21.2,113.5-55.2c20.2-25.8,33-59.2,38.7-101.3c23.2,14,40.4,32.4,49.9,54.5  c16.1,37.6,17.1,99.5-33.4,149.9c-44.2,44.2-97.4,63.3-177.7,63.9c-89.1-0.7-156.5-29.2-200.3-84.9c-41-52.1-62.2-127.5-63-223.9  c0.8-96.4,22-171.7,63-223.9c43.8-55.7,111.2-84.3,200.3-84.9c89.7,0.7,158.3,29.4,203.8,85.3c22.3,27.4,39.1,61.9,50.2,102.2  l63.1-16.8c-13.4-49.5-34.6-92.2-63.3-127.6C700.4,162.7,615.1,126,505.3,125.2h-0.4c-109.7,0.8-194,37.7-250.6,109.7  c-50.4,64.1-76.4,153.2-77.3,265l0,0.3l0,0.3c0.9,111.8,26.9,200.9,77.3,265c56.6,72,141,108.9,250.6,109.7h0.4  c97.5-0.7,166.2-26.2,222.8-82.8c74.1-74,71.8-166.7,47.4-223.7C758,527.8,724.6,494.7,678.9,472.8z M510.6,631  c-40.8,2.3-83.1-16-85.2-55.2c-1.5-29.1,20.7-61.5,87.7-65.4c7.7-0.4,15.2-0.7,22.6-0.7c24.4,0,47.1,2.4,67.8,6.9  C595.9,613.2,550.5,628.8,510.6,631z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreads);
export default __webpack_public_path__ + "static/media/threads.c0dceb564e80547b4f9caca2870625f4.svg";
export { ForwardRef as ReactComponent };